export enum TrendLogbookEntriesType {
    Default,
    Custom
}